/**
 * Created by Administrador on 10/28/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('fareService', fareService);

    fareService.$inject = ['$http', 'CONFIG', 'messageService'];

    function fareService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FARE_CONTROL + '/' + CONFIG.API + '/fares';
        var service = {
            getFares: getFares,
            getAllFares: getAllFares,
            getFare: getFare,
            saveFare: saveFare,
            updateFare: updateFare,
            deleteFare: deleteFare,
            loadForm: loadForm,
            thereFareName: thereFareName
        }

        return service;

        function getFares(page, size, detailed, active){
            var params = (detailed != undefined) ? "&detailed=" + detailed : "";
            params = params + ((active != undefined) ? "&active=" +active : "");
            return $http.get(urlBase + '?page=' + page + '&size=' + size + params)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getAllFares(detailed){
            var params = (detailed != undefined) ? "?detailed=" + detailed : "";
            return $http.get(urlBase + "/list" + params)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getFare(fareId){
            return $http.get(urlBase + "/" + fareId + '?detailed=true')
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function saveFare(fare){
            return $http.post(urlBase, fare)
                .then(function(response){
                    messageService.register('fares');
                    return response;
                })
                .catch(function(){
                    messageService.registerError('fares');
                });
        }

        function updateFare(fareId, fare){
            return $http.put(urlBase + "/" + fareId, fare)
                .then(function(response){
                    messageService.registerUpdate('fares');
                    return response;
                })
                .catch(function(){
                    messageService.registerUpdateError('fares');
                });
        }

        function deleteFare(fareId){
            return $http.delete(urlBase + "/" + fareId)
                .then(function(response){
                    messageService.registerDelete('fares');
                    return response;
                })
                .catch(function(){
                    messageService.registerDeleteError('fares');
                });
        }

        function loadForm(fareId){
            var params = (fareId != undefined) ? "?fareId=" + fareId : "";
            return $http.get(urlBase + "/loadForm" + params)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function thereFareName(fareTradeName) {
            return $http.get(urlBase + "/there-fare-name?name=" + fareTradeName, {headers: {'Loading-Overlay': false}})
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAError('')
                });
        }
    };

})();
